var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:education"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M128.432 122.755L89.391 144.716L50.3499 122.755V99.5527L39.1953 93.3556V129.278L89.391 157.513L139.587 129.278V93.3556L128.432 99.5527V122.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M89.3908 16.5541L11.3086 57.0411V66.7086L89.3908 110.086L156.318 72.9057V103.707H167.473V57.0411L89.3908 16.5541ZM145.164 66.3423L134.009 72.539L89.3908 97.3284L44.7724 72.539L33.6178 66.3423L25.8866 62.0471L89.3908 29.119L152.895 62.0471L145.164 66.3423Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.4cef449c018a9705860648b14c25aec8.svg";
export { ForwardRef as ReactComponent };